// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const CreditHeader = require('components/credits/creditHeader/creditHeader');
const { WarrantiesList } = require('components/contactCenter/creditWarranties/warrantiesList/warrantiesList');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @constants
const { LOANS_MORTGAGES_INVESTMENT_CREDIT } = require('constants/index');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const StringHelper = require('utilities/stringHelper');

class CreditWarranties extends React.Component {

    getAssociatedTitle(creditType) {
        switch (creditType) {
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                return 'investmentCredits-headerTitle';
            default:
                return 'credits-headerTitle';
        }
    }

    buildBreadcrum(immCredit) {
        switch (immCredit.get('type')) {
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                const creditId = immCredit.get('id');
                return [
                    {
                        text: formatText('breadcrumb-home'),
                        url: '/myprofile/'
                    },
                    {
                        text: formatText('breadcrumb-loansAndMortgages'),
                        url: '/myprofile/loans-mortgages/'
                    },
                    {
                        text: formatText('breadcrumb-credit'),
                        url: `/myprofile/loans-mortgages/credit/investment-credit/${creditId}`
                    },
                    {
                        text: formatText('breadcrumb-warranties')
                    }
                ];
            default:
                return [
                    {
                        text: formatText('breadcrumb-credits'),
                        url: '/myprofile/loans-mortgages/'
                    },
                    {
                        text: formatText('breadcrumb-pregrantedCredit', [StringHelper.getLastNChars(immCredit.get('iban'), 4, '.', 4)])
                    }
                ];
        }
    }

    render() {
        const { immCredit } = this.props;
        let content = <LoadingSection />;

        if (immCredit) {
            const headerTitle = this.getAssociatedTitle(immCredit.get('type'));
            const breadcrumb = this.buildBreadcrum(immCredit);
            content = (
                <article>
                    <CreditHeader
                        titleKey={headerTitle}
                        breadcrumbConfig={breadcrumb}
                        immCredit={immCredit}
                    />
                    <OKSectionBox>
                        <WarrantiesList
                            immCredit={immCredit}
                        />
                    </OKSectionBox>
                </article>
            );
        }

        return content;
    }

}

CreditWarranties.propTypes = {
    immCredit: PropTypes.object.isRequired
};

module.exports = CreditWarranties;
